// @flow

import type { AppType } from "shared/types/AppType"

export default ({
  asyncComponentResolve: () => import("apps/backoffice/BackofficeEntry"),
  iconType: "file-text",
  name: "backoffice",
  subApps: [
    {
      name: "deductions",
      requirePermission: "settlement:add"
    },
    {
      name: "rior",
      requirePermission: "backoffice:edit"
    }
  ]
}: AppType)
